<h1>{{ userId ? ("USERS.edit-user" | translate) : ("USERS.add-user" | translate) }}</h1>

<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link routerLink="general" [active]="isActive('general')">
    General
  </a>
  <a mat-tab-link routerLink="signature" [active]="isActive('signature')">
    Signature
  </a>
  <a mat-tab-link routerLink="targets" [active]="isActive('targets')">
    Target
  </a>
</nav>

<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
